import { Injectable, Injector, SecurityContext } from '@angular/core';
import { Subject, Observable, BehaviorSubject, of } from 'rxjs';
import { catchError, finalize, map, shareReplay, take, tap } from 'rxjs/operators';
//import moment = require('moment');
import { AppService } from '../shared/services/app.service';
import get from 'lodash-es/get';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'proxies/dayjs';
import get_ from 'lodash-es/get';
import orderBy from 'lodash-es/orderBy';
import { RolePermissionService } from '../shared/services/role-permission.service';
import { DialogService } from '../components/dialog/dialog.service';
import { DialogModalSize } from '../components/dialog/dialog-ref';
import { BaseService } from '../shared/services/base.service';
import * as CryptoJS from 'crypto-js';
import { MaskPipe } from '../pipes/mask.pipe';
declare var window;

@Injectable({
    providedIn: 'root'
})
export class UtilService {

    private isInProgressObserver = new Subject<boolean>();
    public isInProgress$ = this.isInProgressObserver.asObservable();
    private _boundBarcodeKeydownListener: ((event: KeyboardEvent) => void) | undefined;

    private printPopupSource = new BehaviorSubject<boolean>(false);
    printPopup$: Observable<boolean> = this.printPopupSource.asObservable();
    private maskPipe = new MaskPipe();

    // 198848: GRN_RULES-101 option that switches expiry from month/year to a full DD/MM/YYYY date
    static readonly EXPIRY_DATE_MODULE = "inventory-management";
    static readonly EXPIRY_DATE_CONFIG = "GRN_RULES-101";
    static readonly EXPIRY_DATE_OPTION = "Expiry_date_required_in_DDMMYYYY_format_in_GRN";
    static readonly EXPIRY_FILTER_KEYS = ["fromExpiryDate", "toExpiryDate"];

    // facility_config_mapping records fetched through getFacilityConfig, keyed facility|module|config.
    // A key present with null means "no active record" - it is still never fetched again.
    private facilityConfigs: { [key: string]: any } = {};
    // the one in-flight request per key, so callers arriving while it loads share it instead of re-subscribing
    private facilityConfigRequests: { [key: string]: Observable<any> } = {};

    constructor(private appService: AppService, public sanitizer: DomSanitizer,
        private rolePermissionService: RolePermissionService,
        private dialogService: DialogService,
        private injector: Injector,
    ) { }

    trim(obj: any) {
        let result;
        if (typeof (obj) === 'object') {
            result = {};
            if (obj instanceof Array) {
                result = [];
            }
            for (const key in obj) {
                let value = obj[key];
                if (value !== null && typeof (value) === 'object') {
                    result[key] = this.trim(value);
                } else {
                    if (typeof value === 'string') {
                        value = value.trim();
                    }
                    result[key] = value;
                }
            }
        } else {
            if (typeof obj === 'string') {
                result = obj.trim();
            } else {
                result = obj;
            }
        }
        return result;
    }

    setCurrentPrintPopup(val: boolean) {
        this.printPopupSource.next(val);
    }

    getCurrentPrintPopup(): boolean {
        return this.printPopupSource.getValue();
    }

    // Getter
    getBoundBarcodeListener(): ((event: KeyboardEvent) => void) | undefined {
        return this?._boundBarcodeKeydownListener;
    }

    // Setter
    setBoundBarcodeListener(listener: ((event: KeyboardEvent) => void) | undefined): void {
        this._boundBarcodeKeydownListener = listener;
    }

    unflatten(obj: any) {
        let result = {};
        for (let property in obj) {

            if (obj.hasOwnProperty(property))
                if (property.indexOf('.') !== -1) {
                    //if (obj[property] || obj[property] === 0) {
                    this.parseDotNotation(property, obj[property], result);
                    //}
                } else {
                    result[property] = obj[property];
                }
        }
        return result;
    }
    flatten(obj: any): any {
        const toReturn = {};

        for (const key in obj) {
            if (!obj.hasOwnProperty(key)) {
                continue;
            }
            if ((typeof obj[key]) === 'object' && !(obj[key] instanceof Array)) {
                const flatObject = this.flatten(obj[key]);
                for (const key2 in flatObject) {
                    if (!flatObject.hasOwnProperty(key2)) {
                        continue;
                    }
                    toReturn[key + '.' + key2] = flatObject[key2];
                }
            } else {
                toReturn[key] = obj[key];
            }
        }
        return toReturn;
    }
    private parseDotNotation(str: string, val: any, obj: any) {
        let currentObj = obj,
            keys = str.split('.'),
            i, l = Math.max(1, keys.length - 1),
            key;

        for (i = 0; i < l; ++i) {
            key = keys[i];
            currentObj[key] = currentObj[key] || {};
            currentObj = currentObj[key];
        }

        currentObj[keys[i]] = val;
    }

    startProgress() {
        this.isInProgressObserver.next(true);
    }

    endProgress() {
        this.isInProgressObserver.next(false);
    }

    isOnlyMobile() {
        if (this.isTalbet()) {
            return false;
        } else {
            return this.isMobile();
        }
    }
    isMobile() {
        return /iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(navigator.userAgent) ||
            (navigator.userAgent.includes("Macintosh") && navigator.maxTouchPoints > 1);
    }
    isTalbet() {
        let userAgent = navigator.userAgent.toLowerCase();
        return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent) ||
            (navigator.userAgent.includes("Macintosh") && navigator.maxTouchPoints > 1);
    }
    getWidth() {
        return window.innerWidth;
    }
    getHeight() {
        return window.innerHeight;
    }

    toUtcDate(date: any): any {
        /******* NO NEED */
        // let timeZone;
        // let orgObj = this.appService.getOrganization();
        // if (orgObj != null && orgObj.time_zone != null) {
        //     timeZone = orgObj.time_zone;
        // } else {
        //     timeZone = this.appService._default_user_data.timezone;
        // }
        // moment.tz.setDefault(timeZone);
        /******* NO NEED */
        return moment(date).utc();
    }

    toTimeZoneDate(date: any): any {
        if (date) {
            let timeZone;
            let orgObj = this.appService.getOrganization();
            if (orgObj != null && orgObj.time_zone != null) {
                timeZone = orgObj.time_zone;
            } else if (this.appService._currentSessionData["timeZoneAccountCode"] != undefined && this.appService._currentSessionData["timeZoneAccountCode"]) {
                timeZone = this.appService._currentSessionData["timeZoneAccountCode"];
            } else {
                timeZone = this.appService._default_user_data.timezone;
            }
            moment.tz.setDefault(timeZone);
            return moment(date).tz(timeZone);
        } else {
            return "";
        }

    }

    xmlToJson(xml) {
        var obj = {};
        if (xml.nodeType == 1) { // element
            // do attributes
            if (xml.attributes.length > 0) {
                obj["@attributes"] = {};
                for (let j = 0; j < xml.attributes.length; j++) {
                    var attribute = xml.attributes.item(j);
                    obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
                }
            }
        } else if (xml.nodeType == 3) { // text
            obj = xml.nodeValue;
        }

        // do children
        if (xml.hasChildNodes()) {
            for (let i = 0; i < xml.childNodes.length; i++) {
                var item = xml.childNodes.item(i);
                var nodeName = item.nodeName;
                if (typeof (obj[nodeName]) == "undefined") {
                    obj[nodeName] = this.xmlToJson(item);
                } else {
                    if (typeof (obj[nodeName].push) == "undefined") {
                        var old = obj[nodeName];
                        obj[nodeName] = [];
                        obj[nodeName].push(old);
                    }
                    obj[nodeName].push(this.xmlToJson(item));
                }
            }
        }
        return obj;
    };

    _xmlString(xmlString) {
        var parser = new DOMParser();
        var xml = parser.parseFromString(xmlString, "text/xml");
        return this.xmlToJson(xml);
    }


    parseQrCodeString(event: any) {
        if (typeof event == "string" && event.includes("<?xml")) {
            let _data = this._xmlString(event)['PrintLetterBarcodeData']['@attributes'];
            if (_data.dob) {
                let dob = _data.dob.split("/").map(x => {
                    if (x.length == 1) {
                        return "0" + x
                    } else
                        return x
                }).join("/");
                _data['dob'] = dob;
            }
            _data['nationality_code'] = "indian";
            _data['nationality'] = "Indian";
            _data['identity'] = "aadhaarNumber";
            _data['identityName'] = "Aadhar Card";
            _data['name_.text,name_.family,patient_name'] = _data['name'];
            _data['patient_basic_details.text,patient_basic_details.family,patient_name'] = _data['name'];
            _data['patient_name'] = _data['name'];
            return _data;
        } else if (typeof event == "string" && JSON.parse(event) && (JSON.parse(event).hasOwnProperty('hid') || JSON.parse(event).hasOwnProperty('abhaAddress'))) {
            let _data = JSON.parse(event);
            let dob: any = _data.dob;
            if (_data.dateOfBirth && _data.dateOfBirth.length > 0) {
                dob = _data.dateOfBirth;
            }
            let split: any = "/"
            if (this.findSpecialCharacters(dob).hasSpecial) {
                split = this.findSpecialCharacters(dob).specials[0];
            }
            if (dob) {
                let _dob = dob.split(split).map(x => {
                    if (x.length == 1) {
                        return "0" + x
                    } else
                        return x
                }).join("/");
                _data['dob'] = _dob;
            }
            _data['nationality_code'] = "indian";
            _data['nationality'] = "Indian";
            _data['identityName'] = "Aabha Card";
            return _data;
        } else if (typeof event == "string" && JSON.parse(event) && JSON.parse(event).hasOwnProperty('code_type')) {
            let _data = JSON.parse(event);
            return _data;
        } else {
            return "";
        }
    }

    findSpecialCharacters(str) {
        const matches = str.match(/[^a-zA-Z0-9 ]/g);
        if (matches) {
            return {
                hasSpecial: true,
                specials: [...new Set(matches)]
            };
        } else {
            return {
                hasSpecial: false,
                specials: []
            };
        }
    }

    /**
     * One facility_config_mapping record (GET_CONFIG), fetched at most once per facility + config for the
     * session and shared by every caller: concurrent callers join the in-flight request (getWithCache) and
     * later ones are answered from memory - including "no record", which getWithCache alone would refetch.
     * Emits the record, or null when there is none or the call fails.
     */
    getFacilityConfig(moduleCode: string, configCode: string): Observable<any> {
        const key = this.facilityConfigKey(moduleCode, configCode);
        if (key in this.facilityConfigs) {
            return of(this.facilityConfigs[key]);
        }
        if (!this.facilityConfigRequests[key]) {
            const args = `module_code:${moduleCode},config_code:${configCode}`;
            // BaseService injects UtilService, so it is resolved lazily here instead of in the constructor
            const baseService = this.injector.get(BaseService);
            this.facilityConfigRequests[key] = baseService.getWithCache(key,
                () => baseService.get("GET_CONFIG", args, "facility_config_mapping", "facility-management"))
                .pipe(
                    map((res: any) => res?.data?.[0] || null),
                    catchError(() => of(null)),
                    tap((config) => this.facilityConfigs[key] = config),
                    take(1),
                    finalize(() => delete this.facilityConfigRequests[key]),
                    shareReplay(1)
                );
        }
        return this.facilityConfigRequests[key];
    }

    /**
     * Resolves a screen json's opt-in "config.config_field_overrides" (see CompositeArrayComponent /
     * EditableGridComponent): calls done with the merged { form, list } override maps of the rules whose
     * facility config (and option, when given) is on. Synchronous when the json has no key or the configs
     * are already in memory, so screens without the key render exactly as before; one shared, cached
     * GET_CONFIG per facility + config otherwise (getFacilityConfig).
     */
    resolveConfigFieldOverrides(resourceDef: any, done: (overrides: { form: any, list: any }) => void) {
        const rules = resourceDef?.config?.config_field_overrides;
        const overrides = { form: {}, list: {} };
        if (!Array.isArray(rules) || rules.length == 0) {
            done(overrides);
            return;
        }
        let pending = rules.length;
        rules.forEach(rule => {
            this.getFacilityConfig(rule.module_code, rule.config_code).subscribe((config) => {
                const enabled = rule.option ? this.isConfigOptionEnabled(config, rule.option)
                    : !!config && (config.status == undefined || config.status == "active");
                if (enabled) {
                    Object.assign(overrides.form, rule.form || {});
                    Object.assign(overrides.list, rule.list || {});
                }
                if (--pending == 0) {
                    done(overrides);
                }
            });
        });
    }

    /** fields with their override (by field name) merged over a copy; untouched fields are returned as they are */
    mergeFieldOverrides(fields: any[], overrides: any): any[] {
        if (!Array.isArray(fields) || !overrides || Object.keys(overrides).length == 0) {
            return fields;
        }
        return fields.map(field => field && overrides[field.name] ? { ...field, ...overrides[field.name] } : field);
    }

    /** true when the record is active (or carries no status) and has the multivalue option selected */
    isConfigOptionEnabled(config: any, option: string): boolean {
        return !!config && (config.status == undefined || config.status == "active")
            && Array.isArray(config.multivalue) && config.multivalue.some(m => m && m.id == option);
    }

    /** GRN_RULES-101 "Expiry_date_required_in_DDMMYYYY_format_in_GRN" for the current facility (one shared call) */
    loadExpiryDateFormat(): Observable<boolean> {
        return this.getFacilityConfig(UtilService.EXPIRY_DATE_MODULE, UtilService.EXPIRY_DATE_CONFIG)
            .pipe(map((config) => this.isConfigOptionEnabled(config, UtilService.EXPIRY_DATE_OPTION)));
    }

    /**
     * Synchronous form of loadExpiryDateFormat for code that cannot wait (grid cell formats, resource-def
     * hooks). Before the config has arrived it starts the shared load and answers false, ie. the screen's
     * own json format; preload with loadExpiryDateFormat() where the first render must already be right.
     */
    isExpiryInFullDateFormat(): boolean {
        const key = this.facilityConfigKey(UtilService.EXPIRY_DATE_MODULE, UtilService.EXPIRY_DATE_CONFIG);
        if (key in this.facilityConfigs) {
            return this.isConfigOptionEnabled(this.facilityConfigs[key], UtilService.EXPIRY_DATE_OPTION);
        }
        if (!this.facilityConfigRequests[key]) {
            this.loadExpiryDateFormat().subscribe();
        }
        return false;
    }

    /**
     * Expiry for read-only grid columns: the org date format (DD/MM/YYYY) when the expiry config is on,
     * else `jsonType` - the type the column had in the screen json - exactly as before. Used from screen
     * json composite columns, eg.
     *   "type": "composite", "format": "(item) => (this.utilService || this).formatExpiryDate(item.expiryDate)"
     * (`this` is the editable-grid component there, and UtilService itself inside data-grid's getValue).
     * Cells re-render on change detection, so they switch over by themselves once the config arrives.
     */
    formatExpiryDate(value: any, jsonType: string = 'monthYear'): string {
        if (value === undefined || value === null || value === '' || Number(value) === 0) {
            return '';
        }
        return this.toTimeZoneDateFormat(value, this.isExpiryInFullDateFormat() ? 'date' : jsonType);
    }

    /**
     * End of the given day in the facility timezone, as epoch millis (null for an empty / invalid value).
     * Expiry entered as DD/MM/YYYY means "usable through that day" - the date picker writes start-of-day,
     * the month picker likewise writes end-of-month - and start-of-day IST would print as the previous
     * day in the UTC-formatted GRN print.
     */
    toExpiryEndOfDay(value: any): number | null {
        const millis = Number(value);
        if (!millis) {
            return null;
        }
        return this.toTimeZoneDate(millis).endOf("day").valueOf();
    }

    /**
     * Resource-def form of the same rule, for list screens whose expiry is a plain monthYear column / picker
     * (the stock screens' processResourceDef): with the config on, the expiryDate column becomes a date
     * column, and the expiryDate form picker and the From / To expiry filter pickers become single-date
     * DD/MM/YYYY ones (pair with applyExpiryDateFilter for the filter values). With it off the def is
     * returned untouched, so the screen renders as its json says. Patches a copy, since the def can be the
     * shared JSON_DEF cache.
     */
    applyExpiryDateFormat(resourceDef: any): any {
        if (!resourceDef || !this.isExpiryInFullDateFormat()) {
            return resourceDef;
        }
        const def = JSON.parse(JSON.stringify(resourceDef));
        (def.list?.fields || []).forEach(field => {
            if (field && field.name == "expiryDate" && field.type == "monthYear") {
                field.type = "date";
            }
        });
        (def.form?.blocks || []).forEach(block => {
            (block?.fields || []).forEach(field => {
                if (field && field.name == "expiryDate" && field.component == "monthYearPicker") {
                    // editable expiry keeps the month picker's "no past expiry" rule; a read-only one
                    // gets no min date so an already-expired batch still shows its value
                    this.toExpiryDatePicker(field, !field.disabled);
                }
            });
        });
        (def.list?.filter?.blocks || []).forEach(block => {
            (block?.fields || []).forEach(field => {
                if (field && UtilService.EXPIRY_FILTER_KEYS.includes(field.name) && field.component == "monthYearPicker") {
                    this.toExpiryDatePicker(field, !!field.disablePreviousYearMonth);
                }
            });
        });
        return def;
    }

    /**
     * Filter-value side of applyExpiryDateFormat, for the stock screens' processFilter: with the config on,
     * the From / To expiry filters (now day pickers, which write start-of-day) are sent as start of the from
     * day and end of the to day, so a batch expiring on the to day - stored as end of that day - is included.
     * With it off the filter is returned untouched (the month pickers already send end-of-month).
     */
    applyExpiryDateFilter(filter: string): string {
        if (!filter || typeof filter != "string" || !this.isExpiryInFullDateFormat()) {
            return filter;
        }
        return filter.split(",").map(pair => {
            const separator = pair.indexOf(":");
            const key = separator > -1 ? pair.substring(0, separator).trim() : "";
            const millis = Number(pair.substring(separator + 1));
            if (!UtilService.EXPIRY_FILTER_KEYS.includes(key) || !millis) {
                return pair;
            }
            const day = this.toTimeZoneDate(millis);
            return `${key}:${(key == "fromExpiryDate" ? day.startOf("day") : day.endOf("day")).valueOf()}`;
        }).join(",");
    }

    // month picker -> single-date DD/MM/YYYY picker, optionally keeping "no date before today"
    private toExpiryDatePicker(field: any, noPastDates: boolean) {
        Object.assign(field, {
            type: "date",
            component: "daterangepicker",
            singleDatePicker: true,
            showDropdowns: true,
            locale: { format: "DD/MM/YYYY" },
            format: "DD/MM/YYYY"
        });
        if (noPastDates) {
            Object.assign(field, { autoApply: true, minDateNumber: 0, minDateUnit: "days" });
        }
        delete field.disablePreviousYearMonth;
    }

    private facilityConfigKey(moduleCode: string, configCode: string): string {
        return `facility_config|${this.appService.getOrganization()?.org_id || ""}|${moduleCode}|${configCode}`;
    }

    toTimeZoneDateFormat(date: any, formatType: string): any {
        if (typeof date === 'string') { // Extra check condition if date is not a number
            if (date.indexOf(".")) {
                date = parseFloat(date.trim());//it means long is saved as double
            } else {
                date = parseInt(date.trim());
            }

        }
        if (!date) { return "" }
        let timeZoneDate = this.toTimeZoneDate(date);
        let date_format; let time_format; let dateTime_format;
        let monthYear_format = this.appService._default_user_data.monthYear_format //added by saurav deep for month yaer picker

        let orgObj = this.appService.getOrganization();
        if (orgObj != null && orgObj.date_format != null) {
            date_format = orgObj.date_format;
        } else {
            date_format = this.appService._default_user_data.data_format;
        }
        if (orgObj != null && orgObj.time_format != null) {
            time_format = orgObj.time_format;
        } else {
            time_format = this.appService._default_user_data.time_format;
        }

        if (orgObj != null && orgObj.dateTime_format != null) {
            dateTime_format = orgObj.dateTime_format;
        } else {
            dateTime_format = this.appService._default_user_data.dateTime_format;
        }


        if (formatType == 'date')
            return timeZoneDate.format(`${date_format}`);
        else if (formatType == 'time') {
            return timeZoneDate.format(`${time_format}`);
        } else if (formatType == 'datetime') {
            return timeZoneDate.format(`${dateTime_format}`);
        } else if (formatType == 'monthYear') {
            return timeZoneDate.format(`${monthYear_format}`)
        }
    }

    checkExpression(field, item) {
        let fn;  // Dont remove it, used for format when arrow fn is removed
        if (field.expression != undefined) {
            if (eval(field.expression)) {
                return true;
            } else {
                return false;
            }
        } else if (field.showheading && (item[field.name] || eval(field.format))) {
            return true;
        } else if (field.showheading == undefined || !field.showheading) {
            return true;
        } else if (field.map != undefined) {
            return true;
        } else {
            return false;
        }
    }

    removeObjectLeterSenstivity(item, name) {
        if (name != undefined && !name.includes(".") && name.toLowerCase() != name && item[name.toLowerCase()] != undefined) {
            item[name] = item[name.toLowerCase()];
        }
    }

    buildDynamicValue(str, formatNeeded, item) {
        var finalStr = str;
        const regex = /\!!!(.*?)\!!!/gm;
        let m;
        while ((m = regex.exec(str)) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (m.index === regex.lastIndex) {
                regex.lastIndex++;
            }
            for (let match of m) {
                if (item != undefined && item[match] != undefined) {
                    let key = JSON.parse(JSON.stringify(item[match]));
                    try {

                        if (key.indexOf('<') != -1) {
                            key = key.replace('<', "&lt;")
                        }
                        else if (key.indexOf('>') != -1) {
                            key = key.replace('>', "&gt;")
                        }

                    } catch (error) {
                        // do nothing
                    }
                    finalStr = finalStr.replace('!!!' + match + '!!!', key);
                }
            }
        }
        if (formatNeeded) {
            finalStr = this.extractTextContent(finalStr);
        }
        return finalStr;
    }

    getValue(item: any, field: any, formatNeeded?: any) {
        // debugger;
        var format = field.format;
        const name = field.name;

        var value: any = "";
        let fn; // Dont remove it, used for format when arrow fn is removed
        let ageConfig = localStorage.getItem("ageConfig");
        if (field.checkConfig && ageConfig && Number(ageConfig) > 0) {
            field.checkConfigKey = field.checkConfigKey ? field.checkConfigKey : 'patient_age';
            let val = item[field.checkConfigKey];
            if (val) {
                let valD = val.split(" ");
                if (valD[0] > Number(ageConfig) && valD[1].includes("Y")) {
                    item[field.checkConfigKey] = valD[0] + " Y";
                }
            }
        }
        if (field.type === 'composite' || field.type === 'compositeDate' || field.type === 'compositeDatetime' || field.type === 'compositeTime') {
            if (field.template != undefined && this.appService._appData.TEMPLATE_DEF[field.template] != undefined) {
                format = this.appService._appData.TEMPLATE_DEF[field.template];
                if (field.name != undefined && field.name) {
                    item = get(item, field.name);
                }
            }
            try {
                if (item) {
                    if (formatNeeded) {
                        let tempName = name;
                        if (tempName.indexOf('.')) {
                            tempName = tempName.split('.')[0];
                        }
                        let multi_temp = tempName.split(',');
                        if (multi_temp.length > 1) {
                            multi_temp.forEach(element => {
                                if (element != undefined && item[element] == undefined) {
                                    //for athena which doesn't support column name having capital letters
                                    this.removeObjectLeterSenstivity(item, element)
                                }
                                item[element] = this.convertJavaObjToObj(item[element]);
                            });
                        } else {
                            if (tempName != undefined && item[tempName] == undefined) {
                                //for athena which doesn't support column name having capital letters
                                this.removeObjectLeterSenstivity(item, tempName)
                            }
                            item[tempName] = this.convertJavaObjToObj(item[tempName]);
                        }
                        if (field.excludeFields != undefined && field.excludeFields) {
                            for (let index = 0; index < field.excludeFields.length; index++) {
                                const element = field.excludeFields[index];
                                if (element.indexOf(".") > -1) {
                                    var cFs = element.split(".");
                                    if (cFs[1] != undefined && item[cFs[0]] != undefined && item[cFs[0]][cFs[1]] != undefined) {
                                        delete item[cFs[0]][cFs[1]];
                                    }
                                }
                            }
                        }
                    }
                    let moment_ = moment;  //If it gets removed timepicker will not work
                    value = eval(format)(item);
                    if (!formatNeeded) {
                        return value;
                    } else if (formatNeeded && field.type === 'composite') {

                        return value;
                    }
                    else if (formatNeeded && (field.type === 'compositeDatetime')) {
                        return value != "0" ? this.dateTimeFormat(value) : '';
                    }
                } else {
                    return '';
                }

            } catch (e) {
                return '';
            }
        } else if (field.type === 'auto_column') {
            //TODO, eval if needed
            if (item[field.name] != undefined && this.appService._currentSessionData[field.getterValue] != undefined && this.appService._currentSessionData[field.getterValue][item[field.name]] != undefined && this.appService._currentSessionData[field.getterValue][item[field.name]][field.getterKey] != undefined) {
                return this.appService._currentSessionData[field.getterValue][item[field.name]][field.getterKey];
            }
            return "";

        } else if (field.type === 'multiRow' && formatNeeded) {
            let value = "";
            if (item) {
                value = item[name];
                // let html = this.baseService.buildDyanamicStr(field.format,{data:field.multiRowKey ? item[field.multiRowKey] : item,type:'html'});
                if (value) {
                    return this.extractTextContent(value);
                }
            }
            return value;
        } else if (field.type === 'compositehtmlwithclick') {
            let value = "";
            if (item) {
                try {
                    if (formatNeeded)
                        item[field['name']] = this.convertJavaObjToObj(item[field['name']]);
                    value = eval(format)(item);
                } catch (e) {
                    value = '';
                    // do nothing
                }
                if (value) {
                    if (value.includes!!!) {
                        return (this.buildDynamicValue(value, formatNeeded, (field.name_expression ? eval(field.name_expression) : item[name])));
                    } else
                        if (formatNeeded)
                            return this.extractTextContent(value);
                        else
                            return this.sanitizer.bypassSecurityTrustHtml(value);
                }
            }
            return value;
        } else if (field.type === 'richText' && formatNeeded) {
            let value = "";
            if (item) {
                value = item[name];
                if (value) {
                    return this.extractTextContent(value);
                }
            }
            return value;
        } else if (field.type === 'specialArray' && formatNeeded) {
            let value = "";
            if (item) {
                if (field["getterArrayKey"] != undefined && item[field["getterArrayKey"]] != undefined) {
                    let newItem = item[field["getterArrayKey"]] = this.convertJavaObjToObj(item[field["getterArrayKey"]]);
                    if (newItem && newItem.forEach != undefined) {
                        newItem.forEach(subelement => {
                            var key = (field["setterKey"] != undefined) ? field["setterKey"] : "mode";
                            var getterValue = (field["value"] != undefined) ? field["value"] : "amount";
                            if (subelement[key] != "") {
                                item[subelement[key]] = subelement[getterValue]
                            }
                            if (field && field["name"] && item[field["name"]] == undefined) {
                                item[field["name"]] = "0"
                            }
                        });
                    }

                }
                value = item[name];
                if (formatNeeded && format) {
                    value = eval(format)(item);
                }
                if (value) {
                    return this.extractTextContent(value);
                }
            }
            return value;
        }
        if (field.type === 'compositehtml') {
            try {
                if (item) {
                    let e = eval(format)(item);
                    e = e.replace(/"/g, '\'');
                    let html = this.sanitizer.bypassSecurityTrustHtml(e);
                    if (html && formatNeeded) {
                        html = this.extractTextContent(html);
                    }
                    return html;
                }
            } catch (e) {
                ;
                return '';
            }
        }
        if (field.type === 'array' || field.type == 'timeArray' || field.type == 'dateTimeArray' || field.type == 'htmlArray') {
            let val = [];
            try {
                if (formatNeeded) {
                    item[field.name] = this.convertJavaObjToObj(item[field.name]);
                }
                if (!formatNeeded && typeof (item[field.name]) == 'string') { // For template data was stringified
                    try {
                        item[field.name] = JSON.parse(item[field.name]);
                    } catch (err) {
                        console.log("Error ", err);
                    }
                }
                if (item[field.name] != undefined && item[field.name].length != undefined && item[field.name].length > 0) {
                    for (let i = 0; i < item[field.name].length; i++) {
                        let arrayItem = item[field.name][i];
                        // identity tags (e.g. tag_data) flagged masking_required: mask in grid, download & print
                        if (arrayItem && arrayItem.key_value_display && (arrayItem.masking_required === true || arrayItem.masking_required === 'true')) {
                            arrayItem = { ...arrayItem, key_value_display: this.maskPipe.maskingIdentity(String(arrayItem.key_value_display)) };
                        }
                        let e = eval(format)(arrayItem);
                        if (field.type == 'timeArray')
                            e = this.toTimeZoneDateFormat(e, 'time')
                        if (field.type == 'dateTimeArray')
                            e = this.toTimeZoneDateFormat(e, 'datetime');
                        //ADDED TO ADD WRITE VALUE ONLY
                        if (e) { val.push(e); }
                    }

                    if (formatNeeded) {
                        let t = val.join(",");
                        return this.extractTextContent(t);
                    }
                } else if (item[field.name] == undefined && field.dataKey != undefined) {
                    return field.dataKey;
                }
            } catch (e) {
                console.error(e, format, item)
            }
            if (formatNeeded) {
                return val.join(",");
            }

            return val;
        }
        if (field.type == 'advanceText') {
            if (item[field.name] != undefined && item[field.name].length != undefined && item[field.name].length > 0) {
                return item[field.name];
            }
        }
        if (typeof name == 'function') {
            value = name(item);
        } else {
            if (name != undefined && name.split('.').length > 1) {
                const props = name.split('.');
                value = item;
                for (const v of props) {
                    if (value[v]) {
                        value = value[v];
                    }
                    else if (value[v] == 0) {
                        value = value[v];
                    }
                    else {
                        value = null;
                        break;
                    }
                    if (formatNeeded) {
                        value = this.convertJavaObjToObj(value);
                    }
                }
            } else {
                if (item) {
                    value = item[name];
                }
                if (field.map != undefined) {
                    if (value && formatNeeded) {
                        try {
                            field.map = JSON.parse(atob(field.map));
                        } catch (e) {

                        }
                        if (field.map[value] == undefined) {
                            return "";
                        }
                    }
                    return field.map[value];
                }
            }
            if (value && formatNeeded) {
                if (field.config && field.config.type != undefined) {
                    switch (field.config.type) {
                        case 'time':
                            return this.getTimeVal(value);
                            break;
                        case 'dateWithoutTime':
                            return this.dateToString(value);
                            break;
                        case 'dictionary':
                            return this.getFormattedDictionaryValue(value, field.name);
                            break;

                    }
                }
                switch (field.type) {
                    case 'composite':
                        return this.extractTextContent(value);
                        break;
                    case 'compositeDate':
                    case 'date':
                        return value != "0" ? this.toTimeZoneDateFormat(value, 'date') : '';
                        break;
                    case 'compositeDatetime':
                    case 'datetime':
                        return value != "0" ? this.dateTimeFormat(value) : '';
                        break;
                    case 'compositeTime':
                    case 'time':
                        return value != "0" ? this.toTimeZoneDateFormat(value, 'time') : '';
                        break;
                    case 'monthYear':
                        return value != "0" ? this.toTimeZoneDateFormat(value, 'monthYear') : '';
                        break;
                    case 'currency':
                        return (this.appService.getCurrency("") == "") ? "INR" : this.appService.getCurrency("") + " " + value;
                        break;
                    case 'HashMap':
                        var str: any[];
                        if (item['tag_data'] != undefined) {
                            for (let key of item['tag_data']) {
                                str.push(key.key_name + " : " + key.key_value_display);
                            }
                            return str.join(",");
                        }
                        break;
                }
            }

            if (field.formatter) {
                return field.formatter(value, item);
            }
        }
        return value;
    }

    public getFormattedDictionaryValue(val, key) {
        let result;
        if (val) {
            result = val.map(s => s.configValue).join(', ')
        }
        return result;
    }

    dateTimeFormat(date) {
        let dateFormater = this.toTimeZoneDateFormat(date, 'datetime'); //this.utilService.toTimeZoneDate(date).format(`${default_format} ${time_format}`);    
        //console.log("dateFormatter from date time format ", dateFormater);
        // if (dateFormater.slice(-8) == "00:00 am" || dateFormater.slice(-8) == "12:00 am") { //to remove time if default selected
        //     dateFormater = dateFormater.slice(0, -8)
        //     let temp = dateFormater.split(',')
        //     dateFormater = temp[0]
        // }
        return dateFormater;
    }

    dateFormat(date) {
        let dateFormater = this.toTimeZoneDateFormat(date, 'date'); //this.utilService.toTimeZoneDate(date).format(`${default_format} ${time_format}`);    
        //console.log("dateFormatter from date time format ", dateFormater);
        // if (dateFormater.slice(-8) == "00:00 am" || dateFormater.slice(-8) == "12:00 am") { //to remove time if default selected
        //     dateFormater = dateFormater.slice(0, -8)
        //     let temp = dateFormater.split(',')
        //     dateFormater = temp[0]
        // }
        return dateFormater;
    }

    convertExponentToDate(numIn) {
        numIn += "";
        var sign = "";
        numIn.charAt(0) == "-" && (numIn = numIn.substring(1), sign = "-");
        var str = numIn.split(/[eE]/g);
        if (str.length < 2) return sign + numIn;
        var power = str[1];

        var deciSp = 1.1.toLocaleString().substring(1, 2);
        str = str[0].split(deciSp);
        var baseRH = str[1] || "",
            baseLH = str[0];

        if (power >= 0) {
            if (power > baseRH.length) baseRH += "0".repeat(power - baseRH.length);
            baseRH = baseRH.slice(0, power) + deciSp + baseRH.slice(power);
            if (baseRH.charAt(baseRH.length - 1) == deciSp) baseRH = baseRH.slice(0, -1);

        } else {
            let num = Math.abs(power) - baseLH.length;
            if (num > 0) baseLH = "0".repeat(num) + baseLH;
            baseLH = baseLH.slice(0, power) + deciSp + baseLH.slice(power);
            if (baseLH.charAt(0) == deciSp) baseLH = "0" + baseLH;

        }
        // Rremove leading and trailing 0's and Return the long number (with sign)
        return sign + (baseLH + baseRH).replace(/^0*(\d+|\d+\.\d+?)\.?0*$/, "$1");
    }

    extractTextContent(html: any) {
        try {
            if (html == undefined || html == null) {
                return html;
            }

            let htmlString = '';
            if (typeof html === 'string') {
                htmlString = html;
            } else if (typeof html === 'number' || typeof html === 'boolean') {
                htmlString = String(html);
            } else {
                const sanitized = this.sanitizer.sanitize(SecurityContext.HTML, html);
                htmlString = (typeof sanitized === 'string') ? sanitized : String(html);
            }

            // Normalize common line-break tags before extracting text.
            if (htmlString.includes('<br')) {
                htmlString = htmlString.replace(/<br\s*\/?>/gi, ' ');
            }

            return new DOMParser()
                .parseFromString(htmlString, "text/html")
                .documentElement.textContent ?? '';
        } catch (e) {
            console.error(e);
            return html;
        }

    }
    convertJavaObjToObj(str) {
        if ((typeof str != "string") || str == "" || str == undefined || (str != undefined && str.indexOf('{') == -1 && str.indexOf('}') == -1 && str.indexOf('[') == -1 && str.indexOf(']') == -1)) {
            return str;
        }
        try {
            if (str.indexOf('""') > -1) {
                str = str.replace(/""/g, '"');
            }
            return JSON.parse(str);//parsing normal json
        } catch (e) {
            try {
                return JSON.parse(str.replace(/:,/g, ': ,').replace(/:}/g, ': }').replace(/([a-zA-Z0-9-.#%@_+=\s]+):([a-zA-Z0-9-.#%@_+=\s/]+)/g, "\"$1\":\"$2\""));//replacity without quotes key value pair with quotes key value pair
            } catch (e) {
                //this is the case when value will have comman then we have to manually create the json 
                try {
                    return JSON.parse(str.replace(/:}/g, ': }').replace(/([a-zA-Z0-9-.#%@_+=\s]+):/g, "\"$1\":").replace(/}/g, '"}').replace(/,"/g, '","').replace(/":/g, '":"'));
                } catch (e) {
                    console.error("Error converting java to javascript obj", e, str);
                    return str;
                }
            }
        }

    }
    getTimeVal(date: any) {
        let dateFormatted = moment.unix(date).format("h:mm A");
        return dateFormatted;
    }
    dateToString(date: any) {

        const dateString = new Date(date);
        let dateUnix = moment.unix(date);
        let momentdate = moment(dateUnix, "YYYY-MM-DD");
        return momentdate; //dateString.toDateString();
    }

    isFireFox() {
        return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    }

    isiOS() {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod',
            'MacIntel'
        ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }
    isChorme() {
        return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    }

    isIphone() {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform);
    }

    isMac() {
        return ['MacIntel', 'MacPPC', 'Mac68K', 'Macintosh'].indexOf(navigator.platform) !== -1
    }

    isChrome() {
        return this.isChorme()
    }

    isChormeIOS() {
        return this.isiOS() && this.isChorme();
    }

    isAndroid() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf("android") > -1;
    }

    checkCameraAccessStatus(callback?) {
        navigator.mediaDevices.getUserMedia({
            video: true
        }).then((function (status) {
            if (callback != null) {
                callback()
            }
        }))
    }

    checkAudioAccessStatus() {
        navigator.mediaDevices.getUserMedia({
            audio: true
        }).then((function (status) { }))
    }

    isIE() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
        {
            return true;
        }
        else  // If another browser, return 0
        {
            return false;
        }
    }

    isSafari() {
        var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
            navigator.userAgent &&
            navigator.userAgent.indexOf('CriOS') == -1 &&
            navigator.userAgent.indexOf('FxiOS') == -1;
        return isSafari;
    }

    getImageUrl(documentId, type = 'mediagallery') {
        if (!documentId) {
            return "";
        }
        return "/dms/api/v1/" + type + "/image-response-entity?args=id:" + documentId + "&application=dms";
    }
    isPwa() {
        return (window.matchMedia('(display-mode: standalone)').matches);
    }
    isInstallable(prompt) {
        //Check If Mobile and not pwa
        if (this.isMobile() && !this.isPwa()) {
            console.log("inside isInstallable");
            if (this.isiOS()) { // this works
                //TODO: check if standalone app
                //TODO: check if already installed (no way to do currently)
                console.log("inside isInstallable1");
                if (this.isSafari()) {
                    console.log("inside isInstallable2");
                    return 3;//3 means show add to home screen guide for user
                } else {
                    console.log("inside isInstallable3");
                    return 4;//4 means show open safari browser popup
                }
            } else {
                //android                  
                if (this.isChorme()) {
                    //check if installable
                    console.log("inside isInstallable4");
                    if (prompt.prompt != undefined) {
                        console.log("inside isInstallable5");
                        //not installed
                        return 1;//1 means trigger the install app
                    }
                } else {
                    return 2;//2 means show open chrome and click install button
                }
            }
        }
        return 0;
    }

    isNotSupported() {
        return this.isIE();
    }

    detectWebcam(callback) {
        let md = navigator.mediaDevices;
        if (!md || !md.enumerateDevices) return callback(false);
        md.enumerateDevices().then(devices => {
            callback(devices.some(device => 'videoinput' === device.kind));
        })
    }

    detectMicroPhone(callback) {
        let md = navigator.mediaDevices;
        if (!md || !md.getUserMedia) return callback(false);
        md.enumerateDevices().then(stream => {
            callback(stream.some(device => 'audioinput' === device.kind));
        })
    }

    makeFormatBasedOnType(type, key, heading, order?, format?) {
        var obj: any = { type: type, name: key, format: format }
        if (type.indexOf('composite') != -1 && !format) {
            if (key.indexOf('.') != -1) {
                var keyArr = key.split('.');
                // ["extra_data", "name"]
                // var item = 'item.';
                // keyArr.forEach((key, index) => {
                // item = index == 0 ? item + " ${item." + key + "}" : item + '.' + key;

                // item = index == 0 ? item + key : item + '.' + key;
                // });
                obj['format'] = "(item) =>`${item." + keyArr[0] + " != undefined ? item." + key + " :''} `";
                obj['item'] = "${ item." + keyArr[0] + " != undefined ? item." + key + " :''}";
            } else if (key.indexOf(',') != -1) {
                var keyArr = key.split(',');
                var item = ``;
                keyArr.forEach((key, index) => {
                    item = item + " ${item." + key + " != undefined ? item." + key + " :''} ${item." + key + " != undefined ? '" + key + "' :''}"
                });
                obj['item'] = item;
                obj['format'] = "(item) =>`" + item + "`"
            }
        } else if (type.toLowerCase().indexOf('array') != -1 && key.indexOf('>') != -1 && !format) {
            var keyArr = key.split('>');
            var item = "${item." + keyArr[1] + " != undefined ? item." + keyArr[1] + " :''}"
            obj['format'] = "(item) =>`" + item + "`"
            obj['item'] = item;
            obj['name'] = keyArr[0]
        } else if (type.toLowerCase() == 'string') {
            delete obj.type
        } else if (type.toLowerCase() == 'boolean' && !format) {
            obj.type = 'composite';
            var item = ``;
            item = item + " ${item." + key + " != undefined && (item." + key + " == true || item." + key + " == 'true') ? 'Yes' :'No'}"
            obj['format'] = "(item) =>`" + item + "`"
            obj['item'] = item;
        }
        obj['heading'] = heading;
        if (obj.order)
            obj['order'] = order;
        return obj;
    }

    sort(valueAr: any, type: string = "", key?) {
        //todo implement more sorttype as requiremnt increases
        switch (type) {
            case 'natural':
                let collator = new Intl.Collator('en', { numeric: true, sensitivity: 'base' });
                let sorted = valueAr.sort((a, b) => collator.compare(a.name, b.name));
                return sorted;
                break;
            case 'aplphaNumeric':
                let sortedVal = valueAr.sort((a, b) => {
                    return get(a, key).localeCompare(get(b, key), undefined, {
                        numeric: true,
                        sensitivity: 'base'
                    })
                });
                return sortedVal;
                break;
            default:
                return valueAr;
                break;
        }
    }

    downloadFile(fileData, type, fileName, callback = null) {
        var blob = new Blob([fileData], { type: type });
        if (this.appService.checkNativeApp()) {
            this.nativeFileHandling(blob, type, fileName);
        } else {
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            if (callback != null) {
                callback(true);
            }
        }
    }

    nativeFileHandling(blob, type, fileName) {
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function () {
            var base64data: any = reader.result;
            var base64ContentArray = base64data.split(",");
            var mimeType = base64ContentArray[0].match(/[^:\s*]\w+\/[\w-+\d.]+(?=[;| ])/)[0]
            var decodedFile = base64ContentArray[1];
            console.log(mimeType);
            var argsNative = { mimeType: mimeType, decodedFile: decodedFile, filename: fileName, type: type };
            window.flutter_inappwebview.callHandler('getFileBlob', ...[argsNative]);
        };
    }

    sortData(items, sortObject, field?) {
        try {
            var finalItems: any = [];
            if ((field != undefined && field.type != undefined && (field.type == 'datetime' || field.type == 'time') ? false : (field && !field.stopAlphanumericSort)) && isNaN(Number(get_(items[0], sortObject.key)))) {
                if (sortObject.value == '1') {
                    if (field.type == "composite" && field.composite_sort != undefined && field.composite_sort) {
                        finalItems = items.sort((a, b) => {
                            const aItem = this.getValue(a, field, true);
                            const bItem = this.getValue(b, field, true);
                            return aItem.localeCompare(bItem, undefined, {
                                numeric: true,
                                sensitivity: 'base'
                            })
                        });
                    } else {
                        finalItems = items.sort((a, b) => {
                            return get_(a, sortObject.key).localeCompare(get_(b, sortObject.key), undefined, {
                                numeric: true,
                                sensitivity: 'base'
                            })
                        });
                    }
                }
                else {
                    if (field.type == "composite" && field.composite_sort != undefined && field.composite_sort) {
                        finalItems = items.sort((a, b) => {
                            const aItem = this.getValue(a, field, true);
                            const bItem = this.getValue(b, field, true);
                            return bItem.localeCompare(aItem, undefined, {
                                numeric: true,
                                sensitivity: 'base'
                            })
                        });
                    } else {
                        finalItems = items.sort((a, b) => {
                            return get_(b, sortObject.key).localeCompare(get_(a, sortObject.key), undefined, {
                                numeric: true,
                                sensitivity: 'base'
                            })
                        });
                    }

                }

            }
            else {

                finalItems = orderBy(
                    items,
                    function (o) {
                        return isNaN(Number(o[sortObject.key])) ? get_(o, sortObject.key) : Number(o[sortObject.key]);
                    },
                    [sortObject.value == '1' ? 'asc' : 'desc']
                )
            }
            return finalItems;
        } catch (error) {
            console.error("Error while sorting data");
            return items;
        }
    }

    colorCoding(initial) {
        let color = { "A,B,C,D,E,F": "#4285f4", "G,H,I,J,K": "#bb001b", "L,M,N,O": "#ea4335", "S,T,U": "#FFA500", "V,W,X,Y,Z": "#34a853", "P,Q,R": "rgb(174 75 187)" };
        return Object.keys(color).find(res => res.includes(initial)) ? color[Object.keys(color).find(res => res.includes(initial))] : "#000000";
    }

    compareTwoStrings(first, second) {
        first = first.replace(/\s+/g, '')
        second = second.replace(/\s+/g, '')

        if (first === second) return 1; // identical or empty
        if (first.length < 2 || second.length < 2) return 0; // if either is a 0-letter or 1-letter string

        let firstBigrams = new Map();
        for (let i = 0; i < first.length - 1; i++) {
            const bigram = first.substring(i, i + 2);
            const count = firstBigrams.has(bigram)
                ? firstBigrams.get(bigram) + 1
                : 1;

            firstBigrams.set(bigram, count);
        };

        let intersectionSize = 0;
        for (let i = 0; i < second.length - 1; i++) {
            const bigram = second.substring(i, i + 2);
            const count = firstBigrams.has(bigram)
                ? firstBigrams.get(bigram)
                : 0;

            if (count > 0) {
                firstBigrams.set(bigram, count - 1);
                intersectionSize++;
            }
        }

        return (2.0 * intersectionSize) / (first.length + second.length - 2);
    }

    findBestMatch(mainString, targetStrings) {
        if (!this.areArgsValid(mainString, targetStrings)) throw new Error('Bad arguments: First argument should be a string, second should be an array of strings');

        const ratings = [];
        let bestMatchIndex = 0;

        for (let i = 0; i < targetStrings.length; i++) {
            const currentTargetString = targetStrings[i];
            const currentRating = this.compareTwoStrings(mainString, currentTargetString)
            ratings.push({ target: currentTargetString, rating: currentRating })
            if (currentRating > ratings[bestMatchIndex].rating) {
                bestMatchIndex = i
            }
        }


        const bestMatch = ratings[bestMatchIndex]

        return { ratings: ratings, bestMatch: bestMatch, bestMatchIndex: bestMatchIndex };
    }

    areArgsValid(mainString, targetStrings) {
        if (typeof mainString !== 'string') return false;
        if (!Array.isArray(targetStrings)) return false;
        if (!targetStrings.length) return false;
        if (targetStrings.find(function (s) { return typeof s !== 'string' })) return false;
        return true;
    }

    // Calculate Dice's Coefficient between two strings
    calculateDiceCoefficient(a: string, b: string): number {
        return this.compareTwoStrings(a, b);
    }

    // Calculate Levenshtein distance between two strings
    calculateLevenshteinDistance(a: string, b: string): number {
        const dp: number[][] = Array.from({ length: a.length + 1 }, () => Array(b.length + 1).fill(0));

        for (let i = 0; i <= a.length; i++) {
            for (let j = 0; j <= b.length; j++) {
                if (i === 0) dp[i][j] = j;
                else if (j === 0) dp[i][j] = i;
                else if (a[i - 1] === b[j - 1]) dp[i][j] = dp[i - 1][j - 1];
                else dp[i][j] = 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
            }
        }

        return dp[a.length][b.length];
    }

    padWithLeadingZeros(input: string, length: number): string {
        return input.padStart(length, '0');
    }

    // Combine both methods to find similar strings
    findSimilarStrings(a: string, b: string): number {
        // 1. Exact Match (Highest Priority)
        if (b.toLowerCase() === a.toLowerCase()) {
            return 100; // Perfect match
        }

        // 2. Substring Match
        if (b.toLowerCase().indexOf(a.toLowerCase()) > -1) {
            return 90; // High priority, but not perfect
        }

        // 3. Dice's Coefficient Match (for multi-word searches)
        // The existing logic is fine here.
        // It will check each word in 'b' against 'a'.
        var bAr = b.split(" ");
        const diceCoefficientThreshold = 0.65;
        let maxDiceScore = 0;
        for (const element of bAr) {
            const diceCoefficient = this.calculateDiceCoefficient(a, element);
            if (diceCoefficient >= diceCoefficientThreshold) {
                if (diceCoefficient > maxDiceScore) {
                    maxDiceScore = diceCoefficient;
                }
            }
        }
        if (maxDiceScore > 0) {
            return 80 + (maxDiceScore * 10); // Score between 80 and 90
        }

        // 4. Levenshtein Distance Match (for typos)
        // The threshold was too high. We'll make it dynamic.
        const levenshteinDistance = this.calculateLevenshteinDistance(a, b);
        const levenshteinThreshold = Math.floor(a.length / 2); // Dynamic threshold
        if (levenshteinDistance <= levenshteinThreshold && levenshteinDistance > 0) {
            return 70 + (10 - levenshteinDistance); // Score between 71 and 80
        }

        return 0; // No match
    }
    findCIMSenabledResourceWise(resource?: string) {
        if (resource && resource == "ip_medication_sub_form") {
            const isCimsConfigActive = sessionStorage.getItem('YeK9fx4DQI') === 'true';
            return !isCimsConfigActive && sessionStorage.getItem('KX_CIMS') === 'yes';
        }
        return false;
    }

    checkIfArchiveAvailable(resourceDef, that) {
        if (resourceDef.config != undefined && resourceDef.config.archiveConfig != undefined) {
            if (resourceDef.config.archiveConfig.list != undefined) {
                var selected = false;
                var applied = false;
                if (that._currentData.archiveConfig != undefined && that._currentData.archiveConfig.selected != undefined) {
                    selected = that._currentData.archiveConfig.selected;
                    applied = true;
                }
                that._currentData["archiveConfig"] = resourceDef.config.archiveConfig


                if (selected) {
                    that._currentData["archiveConfig"]["selected"] = selected;
                } else {
                    that._currentData["archiveConfig"]["selected"] = that._currentData["archiveConfig"]["list"][0];
                }
                that._currentData["archiveConfig"]["applied"] = applied;

                /************* START REMOVING FILTER *************/
                if (that._currentData["archiveConfig"].limit_filter != undefined && that._currentData["archiveConfig"].limit_filter) {
                    this.removeFilterForArchive(that._currentData["archiveConfig"], resourceDef, that);
                }
                /************* STOP REMOVING FILTER *************/
            } else {
                that._currentData["archiveConfig"] = resourceDef.config.archiveConfig
            }
        }
        else {
            if (resourceDef.config != undefined && resourceDef.config.catalogue_code != undefined) {
                if (that._currentData["archiveConfig"] == undefined) {
                    that._currentData["archiveConfig"] = {};
                }
                that._currentData["archiveConfig"] = { ...that._currentData["archiveConfig"], ...{ catalogue_code: resourceDef.config.catalogue_code } }
                if (resourceDef.config.hide_catalogue_menu != undefined) {
                    that._currentData["archiveConfig"] = {
                        ...that._currentData["archiveConfig"],  // keep existing properties
                        ...{ hide_catalogue_menu: resourceDef.config.hide_catalogue_menu }
                    }
                }
            }
        }
    }

    removeFilterForArchive(archiveConfig, resourceDef, that) {
        try {
            if (resourceDef.list != undefined && resourceDef.list.filter != undefined && Array.isArray(resourceDef.list.filter.blocks[0].fields)) {
                var selected = that._currentData["archiveConfig"]["selected"];
                var defaultFilter = that._currentData["archiveConfig"]["list"][0];

                for (let i = resourceDef.list.filter.blocks[0].fields.length - 1; i >= 0; i--) {
                    let singleField = resourceDef.list.filter.blocks[0].fields[i];
                    switch (singleField.component) {
                        case "daterangepicker":
                            if (that._currentData["archiveConfig"].FROMTOKEY != undefined && that._currentData["archiveConfig"].FROMTOKEY == singleField.name) {
                                delete singleField.minDateNumber;
                                delete singleField.minDateUnit;
                                delete singleField.maxDateNumber;
                                delete singleField.maxDateUnit;
                                delete singleField.maxSpan;
                                delete singleField.forceEndOfDay;
                                if (selected.minDateNumber != undefined) {
                                    if (this.appService.getArchiveConfigs()[selected.minDateNumber] != undefined) {
                                        singleField.minDateNumber = this.appService.getArchiveConfigs()[selected.minDateNumber];
                                        singleField.minDateUnit = "days";
                                    } else {
                                        that.alerts.error("field.label.Invalid_Input");
                                        console.error("Archive config not correct:minDateNumber", selected)
                                    }

                                }
                                if (selected.maxDateNumber != undefined) {
                                    if (this.appService.getArchiveConfigs()[selected.maxDateNumber] != undefined) {
                                        singleField.maxDateNumber = this.appService.getArchiveConfigs()[selected.maxDateNumber] * -1;
                                        singleField.maxDateUnit = "days";
                                    } else {
                                        that.alerts.error("field.label.Invalid_Input");
                                        console.error("Archive config not correct:maxDateNumber", selected)
                                    }
                                }
                                if (selected.maxSpan != undefined) {
                                    singleField.maxSpan = selected.maxSpan;
                                }
                                if (selected.forceEndOfDay != undefined) {
                                    singleField.forceEndOfDay = selected.forceEndOfDay;
                                }
                                if (selected.id != defaultFilter.id) {//default datasource is not there add it as required
                                    singleField.required = true;
                                }
                            }
                            break;
                        default:
                            break;
                    }
                    if (selected.id != defaultFilter.id && singleField.filters != undefined) {//default datasource is not there removing extra filters
                        if (singleField.filters.indexOf(selected.id) > -1) {
                            if (["daterangepicker"].indexOf(singleField.component) > -1) {
                                delete singleField.selected;
                            }
                        } else {
                            resourceDef.list.filter.blocks[0].fields.splice(i, 1);
                        }
                    }
                }
            }
        } catch (e) {

        }

    }

    applyArchivePoicy(gridData, isSummary, that) {
        if (that._currentData["archiveConfig"] != undefined && that._currentData["archiveConfig"].list != undefined) {
            var argsArchive = "";
            if (that?._currentData?.archiveConfig?.selected != undefined) {
                if (that._currentData["archiveConfig"]["selected"]["id"] != undefined) {
                    argsArchive = "archive_policy:" + that._currentData["archiveConfig"]["selected"]["id"];
                }
                if (that._currentData["archiveConfig"]["selected"]["db_type"] != undefined) {
                    argsArchive += ",archive_db_type:" + that._currentData["archiveConfig"]["selected"]["db_type"]
                }
                if (that._currentData["archiveConfig"]["selected"]["collection"] != undefined) {
                    argsArchive += ",archive_collection:" + that._currentData["archiveConfig"]["selected"]["collection"]
                }
            }
            if (isSummary) {
                if (that?._currentData?.archiveConfig?.selected != undefined && that._currentData["archiveConfig"]["selected"]["apply_on_summary"] != undefined && that._currentData["archiveConfig"]["selected"]["apply_on_summary"]) {
                    if (gridData.args != undefined && gridData.args != "") {
                        gridData.args = gridData.args + ',' + argsArchive;
                    } else {
                        gridData.args = argsArchive;
                    }
                }
            } else {
                if (gridData.args != undefined && gridData.args != "") {
                    gridData.args = gridData.args + ',' + argsArchive;
                } else {
                    gridData.args = argsArchive;
                }
            }

        }
    }

    applyArchiveArgs(printInfo, args, that) {
        if (that._currentData != undefined && that._currentData.archiveConfig != undefined && that._currentData.archiveConfig.selected != undefined) {
            if (that._currentData.archiveConfig.selected.alias_fields != undefined && that._currentData.archiveConfig.selected.alias_fields) {
                args = args + ',aliasFields:' + btoa(encodeURIComponent(JSON.stringify(that._currentData.archiveConfig.selected.alias_fields)));
            }
            if (printInfo && that._currentData.archiveConfig.selected.exclude_fields != undefined && that._currentData.archiveConfig.selected.exclude_fields) {
                printInfo.excludeFields = printInfo.excludeFields ? this.concatExcludeFieldFn(printInfo.excludeFields, that._currentData.archiveConfig.selected.exclude_fields) : that._currentData.archiveConfig.selected.exclude_fields;
            }
            if (that._currentData.archiveConfig.selected.args != undefined && that._currentData.archiveConfig.selected.args) {
                args = args + ',' + that._currentData.archiveConfig.selected.args;
            }
        }
        return { args: args, printInfo: printInfo }
    }

    // For removing duplicate values from array
    concatExcludeFieldFn(existingVal, newVal) {
        try {
            console.log("Existing Value : " + existingVal + " New Value : " + newVal);
            let addedVal = existingVal.concat(newVal);
            return addedVal.filter((item, index) => addedVal.indexOf(item) === index);
        } catch (e) {
            console.error("Error in concatExcludeFieldFn", e);
        }
    }


    haversineDistance(point1: PositionObj, point2: PositionObj): number {
        const R = 6371000; // Earth radius in meters
        const phi1 = (point1.latitude * Math.PI) / 180;
        const phi2 = (point2.latitude * Math.PI) / 180;
        const deltaPhi = ((point2.latitude - point1.latitude) * Math.PI) / 180;
        const deltaLambda = ((point2.longitude - point1.longitude) * Math.PI) / 180;

        const a =
            Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) +
            Math.cos(phi1) * Math.cos(phi2) *
            Math.sin(deltaLambda / 2) * Math.sin(deltaLambda / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return R * c; // Distance in meters
    }

    isInsidePerimeter(source: PositionObj, target: PositionObj, perimeter: number): boolean {
        const distance = this.haversineDistance(source, target);
        return distance <= perimeter;
    }

    async getOtp(): Promise<string | null> {
        const nav = window.navigator as any;
        if (!nav.credentials || !nav.credentials.get) return null;

        try {
            const c = await nav.credentials.get({
                otp: { transport: ['sms'] },
                signal: new AbortController().signal
            });
            return c?.code ?? c?.otp ?? c?.otp_no ?? null;
        } catch (err) {
            console.debug('Web OTP failed:', err);
            return null;
        }
    }

    checkJsonforalignment(json, value) {
        if (json && json.right_align_number && !this.isNumeric(value)) {
            json.right_align_number = false;
        }
        if (json && json.center_align_number && !this.isNumeric(value)) {
            json.center_align_number = false;
        }
        if (json && json.right_align_alphabetic && this.isNumeric(value)) {
            json.right_align_alphabetic = false;
        }
        if (json && json.center_align_alphabetic && this.isNumeric(value)) {
            json.center_align_alphabetic = false;
        }
        if (json && (json.right_align_number || json.right_align_alphabetic)) {
            json["right"] = true
        }
        if (json && (json.center_align_number || json.center_align_alphabetic)) {
            json["center"] = true
        }
        return json;
    }

    transformToDigit(value: any, json: any, summary = false): any {
        if (value === null || value === undefined) return '';

        if (this.shouldSkipFormatting(json)) return value;

        if (json?.commaDisable && !summary) {
            return value;
        }

        if (json.commaDisable == undefined && !summary) {
            return value;
        }

        json = this.checkJsonforalignment(json, value);

        if (this.shouldApplyDefaultDecimals(json, value)) {
            const decimalLimit = this.appService._currentSessionData.currency_decimal_limit;
            value = value + '.' + '0'.repeat(decimalLimit);
        }

        if (this.isAlphanumeric(value)) return value;
        if (Array.isArray(value)) {
            return value.map(item => this.transformToDigit(item, json));
        }

        // Handle negative sign
        const isNegative = value.toString().startsWith('-');
        const numStr = value.toString().replace(/,/g, '');
        const cleanNumStr = isNegative ? numStr.substring(1) : numStr;
        const num = parseFloat(cleanNumStr);

        if (isNaN(num)) return numStr;

        const [wholePart, decimalPart] = cleanNumStr.split('.');
        let decimal = decimalPart ? `.${decimalPart}` : '';

        if (!wholePart) return (isNegative ? '-' : '') + decimal;

        const lastThree = wholePart.slice(-3);
        const rest = wholePart.slice(0, -3);
        if (!rest) return (isNegative ? '-' : '') + lastThree + decimal;

        const chunkSize = this.appService.getUniversalConfig("number_system") || 2;
        const formattedRest = this.formatIndianStyle(rest, chunkSize);

        if (!decimal && json.currency_type) {
            const decimalLimit = this.appService._currentSessionData.currency_decimal_limit;
            decimal = '.' + '0'.repeat(decimalLimit);
        }

        const formattedNumber = `${formattedRest},${lastThree}${decimal}`;
        return (isNegative ? '-' : '') + formattedNumber;
    }

    private formatIndianStyle(value: string, chunkSize: number): string {
        const reversed = value.split('').reverse().join('');
        const chunks = reversed.match(new RegExp(`.{1,${chunkSize}}`, 'g')) || [];
        return chunks.join(',').split('').reverse().join('');
    }

    // Keep all other helper methods the same
    private shouldSkipFormatting(json: any): boolean {
        if (!json) return false;
        const name = json.name?.toLowerCase() || '';
        const type = json.type?.toLowerCase() || '';
        const keywords = ['telecom', 'mobile', 'patient_age', 'dob', 'street', 'contact', 'uhId', 'date', 'code', 'config', 'birthdate', 'time', 'id', 'batchno'];
        const excluded = ['update', 'paid'];
        const keywordMatch = keywords.some(k => name.includes(k));
        const excludedMatch = excluded.some(k => name.includes(k));
        const _typeMatch = ['date', 'time', 'monthyear']
        const typeMatch = _typeMatch.some(y => type.includes(y));
        return (keywordMatch && !excludedMatch) || typeMatch;
    }

    private shouldApplyDefaultDecimals(json: any, value: any): boolean {
        return json?.currency_type &&
            value &&
            !value.toString().includes('.') &&
            this.rolePermissionService.checkdecimalConfig();
    }

    private isAlphanumeric(str: any): boolean {
        return /[a-zA-Z]/.test(str);
    }

    private isNumeric(value: any): boolean {
        if (typeof value === 'number') return isFinite(value);
        if (typeof value === 'string' && value.trim() !== '') {
            try {
                return !isNaN(JSON.parse(value)) && !isNaN(parseFloat(value));
            } catch {
                return false;
            }
        }
        return false;
    }


    // checkDecimalConfig(value){
    //     if(!value.toString().includes('.')) {
    //         return value.toString()+ "."+new Array(this.appService._currentSessionData.currency_decimal_limit).fill(0).join('');
    //     }
    //     return value;
    // }

    printLabel(data, callback?): void {
        import('src/modules/base/components/barcode/barcode.component')
            .then(module => {
                if (module && module.BarcodeComponent) {
                    let obj = { data: data, title: 'Barcode Config', size: DialogModalSize.Sm, className: "modal-sm" };
                    this.dialogService.open(module.BarcodeComponent, obj).afterClosed.subscribe(() => {
                        if (callback) {
                            callback();
                        }
                    })
                } else {
                    console.warn('BarcodeComponent does not exist in the imported module.');
                    if (callback) callback();
                }
            })
            .catch((error) => {
                console.error("Error while loading component", error);
            })
    }

    performPreprintAction(
        baseService: BaseService,
        actionType: any,
        normalCallback: { (res?: any): void; (arg0: undefined): void; },
        mainCallback: { (res: string): void; (arg0: string): void; },
        fallbackTemplateId?: string,
        appendToFileDataArgs = true,
    ): void {
        try {
            let templateId = actionType?.file_data?.template;
            if (!templateId && fallbackTemplateId !== null && fallbackTemplateId !== undefined) {
                templateId = fallbackTemplateId;
            }
            baseService.printTemplateSetting(templateId).subscribe({
                next: (res) => {
                    try {
                        console.log("User Print:", res?.isUserPrint);

                        if (res?.isUserPrint === true) {
                            normalCallback(res)
                        }
                        else if (res?.isUserPrint === false) {
                            let defaultPrint = "Y";

                            if (res && Object.keys(res).length > 0 && res?.print_without_h_f !== null && res?.print_without_h_f !== undefined) {
                                if (res.print_without_h_f == true) {
                                    defaultPrint = "N";
                                }
                                if (appendToFileDataArgs && actionType?.file_data) {
                                    if (actionType?.file_data?.args != null) {
                                        actionType.file_data.args += `,userPrint:${defaultPrint}`;
                                    } else if (actionType?.file_data) {
                                        actionType.file_data.args = `userPrint:${defaultPrint}`;
                                    }
                                }
                                mainCallback(defaultPrint);
                            }
                        } else {
                            normalCallback();
                        }
                    }
                    catch (innerErr) {
                        console.error("Error processing template setting response:", innerErr);
                        normalCallback(res);
                    }
                },
                error: (err) => {
                    console.error("Error fetching print template setting:", err);
                    normalCallback();
                }
            });
        } catch (err) {
            console.error("Unexpected error in match block:", err);
            normalCallback();
        }

    }

    extractValueFromUrlArgsParam(url: string | undefined, paramKey: string | undefined): string {
        let ret = "";
        try {
            // Get query string part after ?
            const queryString = url.split("?")[1] || "";
            const urlParams = new URLSearchParams(queryString);
            // Get the "args" value because the param is inside args
            const args = urlParams.get("args");
            ret = this.extractValueFromArgs(args, paramKey);
        } catch (err) {
            console.error("Error parsing reportTemplateId from URL:", err);
        }
        return ret;
    }

    extractValueFromArgs(args: string, paramKey: string): string {
        let ret = "";
        try {
            console.log("Args string:", args);
            if (args && paramKey) {
                // Extract reportTemplateId using regex
                const match = args.match(new RegExp(`${paramKey}:([^,]+)`));
                if (match && match[1]) {
                    ret = match[1];
                }
            }
            console.log(`Extracted ${paramKey}: ${ret}`);
        } catch (err) {
            console.error("Error parsing reportTemplateId from URL:", err);
        }
        return ret;
    }

    copyToClipboard(text: string): Promise<void> | undefined {
        if (!text) return;
        return navigator.clipboard.writeText(text)
    }

    openWebsite(website, userId) {
        try {
            const parsedUrl = new URL(website);
            const params = parsedUrl.searchParams;
            const method = params.get("method")?.toLowerCase();

            const baseUrlWithPath = parsedUrl.origin + parsedUrl.pathname;

            // ---------------- POST FLOW ----------------
            if (method === "post") {

                // Build payload from URL params
                const payload: Record<string, string> = {};
                params.forEach((value, key) => {
                    if (key !== "label" && key !== "method") {
                        payload[key] = value;
                    }
                });

                // Compute hash ONLY (not sent: timestamp / user_id)
                const timestamp = Date.now().toString();
                const secretKey =
                    this.appService.getAccountConfigValue("website_key");

                const dataToSign = `${timestamp}|${userId}`;
                const hash = CryptoJS.HmacSHA512(dataToSign, secretKey).toString();


                // Create form
                const form = document.createElement("form");
                form.method = "POST";
                form.action = baseUrlWithPath;
                form.target = "_blank";
                payload['hash'] = hash
                payload['timestamp'] = timestamp
                // Add payload fields normally
                Object.entries(payload).forEach(([key, value]) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = key;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);

            } else {
                const newTab = window.open(website, "_blank", "noopener,noreferrer");
                if (newTab) {
                    newTab.focus();
                }
            }

        } catch (e) {
            console.error("openWebsite failed", e);
        }
    }

}


export interface PositionObj {
    latitude: number;
    longitude: number;
}
